import React from "react"
import PropTypes from "prop-types"
import classnames from "classnames"
import { values } from "lodash"

import Column from "../index.jsx"
import ArrowIcon from "@cirrus/legacy/app-common/alt/components/arrowIcon/index.jsx"
import { htmlType } from "../../constants/index.es6"

import commonStyles from "@cirrus/legacy/app-components/table-v2/common-styles/styles.less"

const ExpandColumn = ({
  className,
  htmlType,
  onExpand,
  isRowExpanded,
  isDisabled,
  isLastRowColumn,
}) => {
  return (
    <Column
      htmlType={htmlType}
      className={classnames(commonStyles.expandColumn, commonStyles.controlledWidth, className)}
      isLastRowColumn={isLastRowColumn}
      onClick={(e) => {
        e.stopPropagation()
      }}>
      <ArrowIcon
        isExpanded={isRowExpanded}
        onClick={() => onExpand(!isRowExpanded)}
        disabled={isDisabled}
      />
    </Column>
  )
}

ExpandColumn.propTypes = {
  className: PropTypes.string,
  htmlType: PropTypes.oneOf(values(htmlType)),
  onExpand: PropTypes.func,
  isRowExpanded: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isLastRowColumn: PropTypes.bool,
}

export default ExpandColumn
